import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {Router} from 'react-router';
import App from './App';
import createHistory from 'history/createBrowserHistory';

const history=createHistory();

ReactDOM.render((<Router history={history} ><App /></Router>), document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js